<template>
	<v-dialog slot="activator" v-model="dialog" persistent max-width="600px">
		<v-btn  slot="activator"   >
			BUILDING REPLACEMENT
		</v-btn>
		<v-card>
			<v-toolbar>
				<v-toolbar-title>
					BUILDING REPLACEMENT
				</v-toolbar-title>
			</v-toolbar>
			
			<v-card-text class="" >
				<v-layout row class="body-2 caption pb-2  ">
					<v-flex xs2 class="text-xs-right">
					  	GSF
					</v-flex>
					<v-flex xs2></v-flex>
					<v-flex xs8 class="ml-4">
						ABOR Code
					</v-flex>
				</v-layout>
				<v-divider></v-divider>
				<v-list class="mt-3" dense
					v-if="dvSelectedBuilding">

				<v-list-tile  v-for="(item, index) in newBuildingReplacement" 
					:key="index"
					class="programListTile">
					
					<v-layout row>
						<v-flex xs2 class="">						
						  	<v-text-field 
						  		class="body-1 text-xs-right"               
		                        v-model="item.gsf"
		                        label="GSF"
		                        single-line  
		                        reverse
		                        flat solo   
		                        hide-details                    
		                        @change="changed=true">                   
		                    </v-text-field>
						</v-flex>
						<v-flex xs2></v-flex>
						<v-flex xs7>
							<v-autocomplete	
								autofocus
								class="body-1"
								:items="aborCodes"
								v-model="item.aborCode"
								flat solo
								single-line
								hide-no-data
								hide-details
								label="AborCode"
								item-text="IDAndName"
								item-value="aborCode"
								@change="changed=true">
							</v-autocomplete>
						</v-flex>
						<v-flex xs1 class="px-2 text-xs-right" style="margin-top: 10px !important;">
						<v-tooltip top>		              				                
			                <v-icon small slot="activator" @click="deleteLine(index)" color="red lighten-2">close</v-icon>          
				            <span>Delete</span>
			            </v-tooltip>
					</v-flex>
					</v-layout>

				</v-list-tile>
				<v-flex xs2 class="ml-3 text-xs-right"><v-btn icon @click="addLine" ><v-icon color="grey darken-2">add</v-icon></v-btn></v-flex>
				</v-list>
				
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn v-if="changed" color="green darken-1" flat @click.native="save">
					Save
				</v-btn>
				<v-btn color="green darken-1" flat @click.native="cancel">
					Cancel
				</v-btn>
				
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
	name: "EditBuildingReplacement",

	data() {
		return {
			valid: false,
			dialog: false,
			requiredRules: [v => !!v || "Field is required"],
			changed: false,
			aborCodes: null,
			newBuildingReplacement: null,
			newLine: {	gsf: null,	aborCode: null, },
		}
	},

	watch: {		
		// If there are no lines, add a blank line to the control
		dialog(val) {
			if (val==true) {
				this.changed=false
				// Initially set replacement to a copy of existing replacement 
				this.newBuildingReplacement = [...this.dvSelectedBuilding.buildingReplacement]
					if (this.newBuildingReplacement.length == 0) {
						this.addLine()
					}		
			}
		}
	},

	mounted: async function () {
		this.aborCodes = await this.fetchAborCodes()		
	},

	computed: {
		...mapState({		dvSelectedBuilding: state => state.dv.building,
		})
	},

	methods: {
		...mapMutations([	'setSnackText', 'setdvBuilding'										]),
		...mapActions([		'fetchAborCodes', 'updateBuildingReplacement', 'fetchBuilding'		]),

		addLine: function () {
	    	this.newBuildingReplacement.push({...this.newLine})
	    },

	    deleteLine: function (index) {
	    	this.changed=true
	    	this.$delete(this.newBuildingReplacement, index)
	    },

	    save: function() {
			 
			// Validate Form 

			// Update database with Building Replacement
			let payload = {}
			payload.bldgAlpha = this.dvSelectedBuilding.bldgAlpha
			payload.buildingReplacement = this.newBuildingReplacement
			this.updateBuildingReplacement(payload).then((response) => {
				this.setSnackText(response) 
				if (response=="Saved") {
					this.refreshBuilding()
				}
			})

			this.dialog=false
			
		},

		refreshBuilding: function() {
			this.fetchBuilding(this.dvSelectedBuilding.bldgAlpha).then((data) =>
						{ this.setdvBuilding(data) })
		},

		cancel: function() {
			this.newBuildingReplacement = [...this.dvSelectedBuilding.buildingReplacement]
			this.dialog=false
		},
	}
}

</script>

<style>
	
.programListTile > .v-list__tile {
	height: 11px !important;
	padding-left: px;
	margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/BldgViewer/EditBuildingReplacement.vue